import type { PaginationLabels } from '@rango-dev/whale/lab';

import { useTranslation } from 'react-i18next';

export function usePaginationLabels(): PaginationLabels {
  const { t } = useTranslation();

  return {
    goToFirstPage: t('Go to first page'),
    goToPreviousPage: t('Go to previous page'),
    goToNextPage: t('Go to next page'),
    goToLastPage: t('Go to last page'),
    goToPage: t('Go to Page'),
    emptyFieldError: t('Please fill out this field.'),
    nonNumericError: t('Only numbers are allowed in this field.'),
    nonIntegerError: t('Only integers are allowed in this field.'),
    outOfRangeError: (totalPages: number) =>
      t('Please enter a number within the range 1-{{totalPages}}.', { totalPages }),
  };
}
